import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PostgenieService {
    public messageSubject = new BehaviorSubject<string>('');

    get prompt() {
        return this.messageSubject.value;
    }

    set prompt(message) {
        this.messageSubject.next(message);
    }

    sendPrompt(prompt: string) {
        this.messageSubject.next(prompt);
    }
}
